export const isEmpty = (value) => {
  return !value || !value.trim();
};
